"use strict";

exports.__esModule = true;
exports.DashboardFields = DashboardFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Translator = require("../../Core/Translator");
var _ElementLayoutVisibilityControlGroup = require("../../ConfigurableLayout/ElementEditor/ControlGroups/ElementLayoutVisibilityControlGroup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DashboardElement.
 */
function DashboardFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ElementLayoutVisibilityControlGroup.ElementLayoutVisibilityControlGroup, {
      elementEditor: elementEditor,
      path: path,
      element: element
    }), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementCanvasSizeControlGroup, {
      elementEditor: elementEditor,
      path: path,
      element: element
    }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DashboardFields.rows.label", "Rows"),
      helperText: translate("DashboardFields.rows.helperText", "The number of horizontal rows.")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DashboardFields.slider.rows"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 3,
      max: 48,
      value: element.props.rowCount || 12,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "rowCount", value);
      }
    }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DashboardFields.columns.label", "Columns"),
      helperText: translate("DashboardFields.columns.helperText", "The number of vertical columns")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DashboardFields.slider.columnCount"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 3,
      max: 48,
      value: element.props.columnCount || 12,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "columnCount", value);
      }
    }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DashboardFields.padding.label", "Padding"),
      helperText: translate("DashboardFields.padding.helperText", "The padding around the element.")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DashboardFields.slider.padding"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 64,
      value: element.props.padding || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "padding", value);
      }
    }))));
  });
}